/**
 * ListViewSchema for Pricing Rule DocType
 * 
 * Schema-driven configuration for Pricing Rule list page.
 * 
 * This schema replaces hardcoded column definitions and default filters.
 * All list layout changes should be made in this file.
 */

import type { ListViewSchema } from "./types";

export const pricingRuleListViewSchema: ListViewSchema = {
  doctype: "Pricing Rule",
  views: {
    experience: {
      columns: [
        {
          fieldname: "name",
          label: "Name",
          width: 200,
          align: "left",
          type: "Data",
          sortable: true,
        },
        {
          fieldname: "title",
          label: "Title",
          width: "grow",
          align: "left",
          type: "Data",
          sortable: true,
        },
        {
          fieldname: "apply_on",
          label: "Apply On",
          width: 140,
          align: "left",
          type: "Link",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "applicable_for",
          label: "Applicable For",
          width: 140,
          align: "left",
          type: "Link",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "rate_or_discount",
          label: "Rate/Discount",
          width: 120,
          align: "left",
          type: "Data",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "discount_percentage",
          label: "Discount %",
          width: 120,
          align: "right",
          type: "Float",
          sortable: true,
        },
        {
          fieldname: "valid_from",
          label: "Valid From",
          width: 140,
          align: "left",
          type: "Date",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "valid_upto",
          label: "Valid Upto",
          width: 140,
          align: "left",
          type: "Date",
          sortable: true,
          hideOnMobile: true,
        },
      ],
      defaultSort: {
        fieldname: "modified",
        direction: "desc",
      },
      defaultFilters: [],
      quickFilters: [
        {
          id: "all",
          label: "All",
          filters: [],
          default: true,
        },
        {
          id: "active",
          label: "Active",
          filters: [["disable", "=", 0]],
        },
        {
          id: "disabled",
          label: "Disabled",
          filters: [["disable", "=", 1]],
          pillVariant: "danger",
        },
      ],
      pageSizeOptions: [20, 50, 100, 200, 400, 500],
    },
  },
};

